import { WiDaySunnyOvercast } from 'react-icons/wi';
import {
  TbArrowRight,
  TbBolt,
  TbBuilding,
  TbCalendar,
  TbChartBarPopular,
  TbCheck,
  TbClock,
  TbLeaf,
  TbLogout,
  TbMap,
  TbSalad,
  TbWashMachine,
  TbUsers,
  TbMapPin,
  TbCalendarMinus,
  TbUser,
  TbBookmark,
  TbSortAscending,
  TbSortDescending,
  TbArrowDown,
  TbBusStop,
  TbFiles,
  TbFlag2,
  TbUserSquare,
  TbClipboardText,
  TbArrowLeft,
  TbList,
  TbBike,
  TbChargingPile,
  TbCampfire,
  TbWeight,
  TbHeartHandshake,
  TbParking,
  TbStar,
  TbAlertTriangle,
  TbDeviceGamepad2,
} from 'react-icons/tb';
import { LuInfo, LuNetwork, LuSquarePlay } from 'react-icons/lu';
import { HiMiniSignal } from 'react-icons/hi2';
import { RiHomeFill } from 'react-icons/ri';
import { BiSupport } from 'react-icons/bi';

export const IconCloudSunny = WiDaySunnyOvercast;

export const IconBuilding = TbBuilding;

export const IconRestaurant = TbSalad;

export const IconLeaf = TbLeaf;

export const IconMap = TbMap;

export const IconFlash = TbBolt;

export const IconVideo = LuSquarePlay;

export const IconInfoCircle = LuInfo;

export const IconNetwork = LuNetwork;

export const IconSignal = HiMiniSignal;

export const IconReports = TbChartBarPopular;

export const IconGroup = TbUsers;

export const IconUser = TbUser;

export const IconCheck = TbCheck;

export const IconLogOut = TbLogout;

export const IconArrowRight = TbArrowRight;

export const IconArrowDown = TbArrowDown;

export const IconArrowLeft = TbArrowLeft;

export const IconCalendar = TbCalendar;

export const IconCalendarMinus = TbCalendarMinus;

export const IconWashingMachine = TbWashMachine;

export const IconClock = TbClock;

export const IconMapPin = TbMapPin;

export const IconBookmark = TbBookmark;

export const IconSortAsc = TbSortAscending;

export const IconSortDesc = TbSortDescending;

export const IconBusStop = TbBusStop;

export const IconFiles = TbFiles;

export const IconFlag = TbFlag2;

export const IconUserSquare = TbUserSquare;

export const IconClipboard = TbClipboardText;

export const IconList = TbList;

export const IconHomeSimple = RiHomeFill;

export const IconBicycle = TbBike;

export const IconEvCharge = TbChargingPile;

export const IconFireFlame = TbCampfire;

export const IconGym = TbWeight;

export const IconHealthcare = TbHeartHandshake;

export const IconHomeTable = BiSupport;

export const IconParking = TbParking;

export const IconStar = TbStar;

export const IconWarningTriangle = TbAlertTriangle;

export const IconGamepad = TbDeviceGamepad2;
